module.exports = __webpack_public_path__ + "static/icons/icon-altitude-b5db52dbf0cd5f8a975fe45abb7cc232.svg";